import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RecuperarPasswordService } from './recuperar-password.service';
import { SnackbarService } from '../services/snackbar-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../_module/entidad/procesamiento/confirm-dialog/confirm-dialog.component';
import { DialogTipo } from '../custom-components/dialog/utils/dialog-type.enum';


@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styleUrls: ['./recuperar-password.component.scss']
})
export class RecuperarPasswordComponent {

  form: FormGroup;
  backendMessage: string = '';
  correoEnviado: string = '';
  isSuccess: boolean = false;
  isProcessing: boolean = false;
  retryCount: number = 0;
  maxRetries: number = 3;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RecuperarPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private recuperarPasswordService: RecuperarPasswordService,
    private snackbarSvc: SnackbarService,
    private dialog: MatDialog
  ) {
    this.form = this.fb.group({
      usuario: [
        data?.usuario || '',
        [Validators.required, Validators.pattern('[0-9]+$')]
      ],
    });
  }

  enviarCodigo(): void {

    if (this.form.invalid || this.isProcessing) {
      this.form.markAllAsTouched();
      return;
    }

    const usuario = this.form.get('usuario')?.value;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: {
        titulo: 'Confirmar recuperación de contraseña',
        mensaje: `¿Está seguro de solicitar el cambio de contraseña para el usuario <b> ${usuario} </b>?`,
        buttons: ['cancel', 'confirm']
      }
    });

    dialogRef.afterClosed().subscribe((confirmado: boolean) => {

      if (!confirmado) return;


      this.isProcessing = true;
      this.form.get('usuario')?.disable();
      this.isSuccess = false;

      this.recuperarPasswordService.enviarCodigoRecuperacion({ usuario })
        .subscribe({
          next: (res: any) => {

            if (res?.success) {

              this.backendMessage = res.message;
              this.correoEnviado = res.correo;

              this.isSuccess = true;
            }
            this.isProcessing = false;

            this.snackbarSvc.showMessage(
              'Solicitud procesada correctamente.',
              'success'
            );
          },

          error: (error) => {
            const mensajeError = error.error.message
            this.isProcessing = false;
            this.form.get('usuario')?.enable();

            this.snackbarSvc.showMessage(
             mensajeError, 'warning'
            );
          }
        });

    });
  }

  reenviarCodigo(): void {

  if (this.retryCount >= this.maxRetries) {
    this.snackbarSvc.showMessage(
      'Se ha excedido el límite de reenvíos.',
      'warning'
    );
    return;
  }

  const usuario = this.form.get('usuario')?.value;

  this.retryCount++;

  this.enviarCodigoSinConfirmacion(usuario);
}

  private enviarCodigoSinConfirmacion(usuario: string): void {

    this.isProcessing = true;

    this.recuperarPasswordService.enviarCodigoRecuperacion({ usuario })
      .subscribe({
        next: (res: any) => {

          if (res?.success) {
            this.backendMessage = res.message;
            this.correoEnviado = res.correo;
            this.isSuccess = true;
          }

          this.isProcessing = false;
        },

        error: () => {

          this.isProcessing = false;

          this.snackbarSvc.showMessage(
            'No fue posible procesar la solicitud.',
            'warning'
          );
        }
      });
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}